<div class="code-renderer">

  <h4 *ngIf="isSummary" class="title pb-1">{{codeValue.title}}</h4>

  <div *ngIf="!(isSummary)" class="static-label-above">{{codeValue.title}} <span class="sub-heading" *ngIf="subHeading">{{subHeading}}</span></div>

  <div class="multiline item pr-2 back-code-value" [innerText]="codeValue.value"></div>

</div>